import React, { useState } from "react";
import { FaPhone, FaEnvelope, FaHome } from "react-icons/fa";
import { Helmet } from "react-helmet";

function Contact() {
  const [showThankYou, setShowThankYou] = useState(false);

  const [formData, setFormData] = useState({
    nome: "",
    cognome: "",
    email: "",
    telefono: "",
    messaggio: "",
  });

  const handleChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value,
    });
  };

  const handleSubmit = (e) => {
    e.preventDefault();

    setShowThankYou(true);

    setTimeout(() => {
      setShowThankYou(false);

      setFormData({
        nome: "",
        cognome: "",
        email: "",
        telefono: "",
        messaggio: "",
      });
    }, 5000);
  };

  return (
    <>
      <Helmet>
        <title>
          Haridem - Photography Studio Premium | Servizi Fotografici
          Professionali
        </title>
        <meta
          name="description"
          content="Haridem Photography Studio - Servizi fotografici professionali premium, ritratti artistici, gallerie contemporanee e attrezzatura fotografica di alta qualita"
        />
      </Helmet>

      <div className="contact-container">
        <h1 className="page-title">Contattaci</h1>

        <div className="contact-grid">
          <div className="contact-info">
            <h2>Informazioni di Contatto</h2>

            <div className="info-item">
              <div className="info-icon">
                <FaHome />
              </div>
              <div className="info-text">
                <h3>Indirizzo Studio</h3>
                <p>lungomare Leopoldo II di Lorena, 91</p>
                <p>58100 grosseto GR</p>
                <p>Italia</p>
              </div>
            </div>

            <div className="info-item">
              <div className="info-icon">
                <FaPhone />
              </div>
              <div className="info-text">
                <h3>Telefono</h3>
                <p>+39 4713811587</p>
                <p>Lun-Ven: 9:00 - 18:00</p>
                <p>Sab: 9:00 - 14:00</p>
              </div>
            </div>

            <div className="info-item">
              <div className="info-icon">
                <FaEnvelope />
              </div>
              <div className="info-text">
                <h3>Email</h3>
                <p>
                  <a href="mailto:haridem@hotmail.com">haridem@hotmail.com</a>
                </p>
              </div>
            </div>

            <div className="info-item">
              <div className="info-icon">
                <FaHome />
              </div>
              <div className="info-text">
                <h3>Partita IVA</h3>
                <p>01916989</p>
              </div>
            </div>
          </div>

          <div className="contact-form-container">
            <h2>Inviaci un Messaggio</h2>

            {showThankYou && (
              <p className="success-message">
                Grazie per il tuo messaggio! Ti contatteremo presto.
              </p>
            )}

            <form onSubmit={handleSubmit} className="checkout-form">
              <div className="form-row">
                <div className="form-group">
                  <label htmlFor="nome">Nome</label>
                  <input
                    type="text"
                    id="nome"
                    name="nome"
                    value={formData.nome}
                    onChange={handleChange}
                    required
                  />
                </div>

                <div className="form-group">
                  <label htmlFor="cognome">Cognome</label>
                  <input
                    type="text"
                    id="cognome"
                    name="cognome"
                    value={formData.cognome}
                    onChange={handleChange}
                    required
                  />
                </div>
              </div>

              <div className="form-row">
                <div className="form-group">
                  <label htmlFor="email">Email</label>
                  <input
                    type="email"
                    id="email"
                    name="email"
                    value={formData.email}
                    onChange={handleChange}
                    required
                  />
                </div>

                <div className="form-group">
                  <label htmlFor="telefono">Telefono</label>
                  <input
                    type="tel"
                    id="telefono"
                    name="telefono"
                    pattern="^\+?[0-9\s\-]{7,20}$"
                    value={formData.telefono}
                    onChange={handleChange}
                    required
                  />
                </div>
              </div>

              <div className="form-group full-width">
                <label htmlFor="messaggio">Messaggio</label>
                <textarea
                  id="messaggio"
                  name="messaggio"
                  value={formData.messaggio}
                  onChange={handleChange}
                  required
                ></textarea>
              </div>

              <button type="submit" className="send-btn">
                Invia Messaggio
              </button>
            </form>
          </div>
        </div>
      </div>
    </>
  );
}

export default Contact;
